import * as RadPopover from '@radix-ui/react-popover'
import { useAtom } from '@reatom/npm-react'
import React from 'react'
import DatePicker from 'react-datepicker'
import styled from 'styled-components'

import { languageAtom } from '@root/shared/localization/atoms'

import 'react-datepicker/dist/react-datepicker.css'

type DateInputCalendarProps = {
  children: React.ReactNode
  open: boolean
  value?: Date
  onOpenChange: (open: boolean) => void
  onAccept: (date: Date) => void
}

export const DateInputCalendar: React.FC<DateInputCalendarProps> = ({
  children,
  open,
  value,
  onOpenChange,
  onAccept,
}) => {
  const [lang] = useAtom(languageAtom)
  const handleDateChange = (date: Date | null) => {
    if (date) {
      onAccept(date)
    }
  }

  return (
    <Root open={open} onOpenChange={onOpenChange}>
      <Trigger asChild>{children}</Trigger>
      <RadPopover.Portal>
        <Content side="bottom" align="end">
          <DatePicker
            selected={value}
            selectsRange={false}
            onChange={handleDateChange}
            locale={lang}
            inline
          />
        </Content>
      </RadPopover.Portal>
    </Root>
  )
}

export const Root = styled(RadPopover.Root)``
export const Trigger = styled(RadPopover.Trigger)`
  cursor: pointer;
`

export const Content = styled(RadPopover.Content)`
  background: var(--background-1);
  box-shadow: 2px 2px 9px 1px rgb(0 0 0 / 30%);
  backdrop-filter: blur(22.5px);

  overflow: hidden;
  /* padding: 10px; */
  gap: 2px;
  display: grid;

  border-radius: 10px;
  margin-top: 20px;
  margin-right: -12px;

  .react-datepicker {
    border: none;
    background: var(--background-1);

    .react-datepicker__month-container {
      padding: 10px;
    }
    .react-datepicker__header {
      border-bottom: 1px solid var(--background-3);
      background: none;
      padding: 2px 0 8px;
    }
    .react-datepicker__navigation {
      top: 6px;
    }
    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name,
    .react-datepicker__current-month {
      color: var(--text-8);
    }

    .react-datepicker__current-month {
      margin-bottom: 10px;
      font-size: 14px;
    }

    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow,
    .react-datepicker__navigation-icon::before {
      border-color: var(--background-8);
      border-width: 2px 2px 0 0;
      height: 7px;
      width: 7px;

      &:hover {
        color: var(--primary-12);
      }
    }

    .react-datepicker__day--keyboard-selected,
    .react-datepicker__month-text--keyboard-selected,
    .react-datepicker__quarter-text--keyboard-selected,
    .react-datepicker__year-text--keyboard-selected,
    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--selected,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--selected,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--selected,
    .react-datepicker__year-text--in-selecting-range,
    .react-datepicker__year-text--in-range {
      background: var(--primary-9);
      color: var(--primary-contrast);
    }
  }
`

// const Calendar = styled(DatePicker)``
